import React from 'react';

export function AddContributionModal({ contributionData, setContributionData, familyMembers, onSubmit, onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6" data-testid="add-contribution-modal">
        <h3 className="text-2xl font-bold text-gray-800 mb-4">Add Contribution</h3>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium mb-2">Contributor</label>
            <select
              value={contributionData.contributor}
              onChange={(e) => setContributionData({ ...contributionData, contributor: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent"
              required
              data-testid="contribution-contributor-select"
            >
              <option value="">Select contributor</option>
              {familyMembers.map((member) => (
                <option key={member.user_id} value={member.user_id}>
                  {member.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-gray-700 font-medium mb-2">Amount ($)</label>
            <input
              type="number"
              step="0.01"
              value={contributionData.amount}
              onChange={(e) => setContributionData({ ...contributionData, amount: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent"
              required
              data-testid="contribution-amount-input"
            />
          </div>
          <div className="flex space-x-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
              data-testid="submit-contribution-btn"
            >
              Add Contribution
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
